module.exports = __webpack_public_path__ + "media/images/gallery/8-4e1ceef21b356c27c718a9416ffb5b36.jpg";